import { useState } from 'react'
import QuestLeftIcon from '../../images/soefia-assessment/btn_arrow-left.png';
import QuestLeftActiveIcon from '../../images/soefia-assessment/btn_arrow-left-active.png';
import QuestLeftDisabledIcon from '../../images/soefia-assessment/btn_arrow-left-disabled.png';
import QuestRightIcon from '../../images/soefia-assessment/btn_arrow-right.png';
import QuestRightActiveIcon from '../../images/soefia-assessment/btn_arrow-right-active.png';
import QuestRightDisabledIcon from '../../images/soefia-assessment/btn_arrow-right-disabled.png';
// import useIsMobileView from "../../hooks/useIsMobileView";

export default ({
  direction,
  onClick,
  isDisabled
}) => {

  const [isHovered, setIsHover] = useState(false)

  const isMobileView = true // useIsMobileView();

  const chevronWrapperStyle = {
    cursor: isDisabled ? 'default' : 'pointer',
    position: 'absolute',
    top: isMobileView ? 'auto' : '50%',
    bottom: isMobileView ? '20px' : 'auto',
    left: direction === 'left' ? (isMobileView ? '7px' : '15px') : 'auto',
    right: direction === 'right' ? (isMobileView ? '7px' : '15px') : 'auto',
    // background: isDisabled ? '#7E7E7ECC' : '#7E7E7E',
    background: 'transparent',
    padding: isMobileView ? '15px' : '20px',
    borderRadius: '50%',
    width: '100px',
    // height: '100px'
  }

  // const chevronStyle = {
  //   color: isDisabled ? '#CECECECC' : '#FFFFFF',
  //   fontSize: isMobileView ? '18px' : '34px',
  //   position: 'relative',
  //   top: '1px',
  //   left: direction === 'left' ? '-3px' : 'auto',
  //   right: direction === 'right' ? '-3px' : 'auto',
  // }

  return (
    <div style={chevronWrapperStyle} onClick={onClick} onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
      {
        direction === 'left' 
        ?
        <img src={isDisabled ? QuestLeftDisabledIcon : isHovered ? QuestLeftActiveIcon : QuestLeftIcon} style={{ width: '100%', height: '100%' }} alt="leftChevron" />
        :
        <img src={isDisabled ? QuestRightDisabledIcon : isHovered ? QuestRightActiveIcon : QuestRightIcon} style={{ width: '100%', height: '100%' }} alt="leftChevron" />
      }
    </div>
  )
}